import React from "react";
import { MetricType } from "../lib/types/MetricType";
import { QuoteType } from "../lib/types/QuoteType";
import { QuoteActionTypes } from "./quote-reducer";
import { QuoteState } from "./quote-state";

type Dispatch = (action: QuoteActionTypes) => void;

export interface IQuoteContext {
  state: QuoteState;
  dispatch: Dispatch;
  fetchQuote: () => void;
  saveQuoteHelper: (quote: any, isCopy?: boolean) => void;
  calculateQuote: (quote: any) => void;
  deleteQuote: (quote: any) => void;
  saveQuoteMetrics: (metric: MetricType) => Promise<void>;
  submitQuoteHandler: (quote: any) => void;
  isOwned?: boolean;
  quoteType: QuoteType;
  quoteId?: number;
}

export const QuoteContext = React.createContext<IQuoteContext | undefined>(
  undefined
);
